import ParallaxSection from "../components/shared/ParallaxSection";
import ParallaxTwoColumn from "../components/shared/ParallaxTwoColumn";
import CallToAction from "../components/shared/CallToAction";
import Review from "../components/shared/Review";

import Magazine from "../components/shared/Magazine";
import IndustryPartners from "../components/shared/IndustryPartners";
import StatTiles from "../components/shared/StatTiles";
import HomeCourses from "../components/shared/HomeCourses";
import InstructorsSection from "../components/shared/InstructorsSection";
import { useEffect, useRef, useState } from "react";
import { getHomePageData, getSEOPageData } from "../services/pagesService";
import CommunitySection from "../components/shared/CommunitySection";
import SEO from "../components/shared/SEO";
import ParallaxTwoColVideoSec from "../components/shared/ParallaxTwoColVideoSec";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSeoData } from "../store/slices/seoSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import $ from "jquery";
import "jquery.marquee";

import "swiper/css/navigation";
import Loading from "../components/shared/Loading";
import { RightArrowIcon } from "../components/shared/RightArrow";

export default function Home() {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [seoData, setSeoData] = useState<any>(null);
  // const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const marqueeRef: any = useRef(null);
  const [currentSelectedItem, setCurrentSelectedItem] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const seoData: any = await getSEOPageData("/home");
      dispatch(getSeoData(seoData?.data));
      const data: any = await getHomePageData();
      setSeoData(seoData?.data);
      setData(data?.data);
      setIsLoading(false);
    };

    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(
    function () {
      const $el: any = $(marqueeRef.current);
      if (data?.page?.home?.homeBanner?.brandArea.length > 0) {
        $el.marquee({
          speed: 20,
          gap: 35,
          delayBeforeStart: 0,
          direction: "left",
          duplicated: true,
          pauseOnHover: true,
          startVisible: true,
        });
      }
    },
    [data]
  );

  const banner_links = [
    {
      banner: 1,
      url: "https://mecat.in",
    },
    {
      banner: 2,
      url: "/awsitc",
    },
    {
      banner: 3,
      url: "/creative-warriors",
    },
    {
      banner: 4,
      url: "/vidyadaan",
    },
  ];

  useEffect(() => {
    setCurrentSelectedItem(
      data?.page?.home?.industryAreaSection?.industryAreaRepeater[0]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {seoData && (
        <SEO
          title={seoData.title}
          description={seoData?.description}
          canonicalUrl={seoData?.canonicalUrl}
          robots={seoData?.robots}
          jsonLd={seoData.jsonLd?.raw}
        />
      )}
      <main className="main-area fix">
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          loop={true}
          // autoplay={{
          //   delay: 5000,
          //   disableOnInteraction: false,
          // }}
          autoplay={false}
          navigation
          onSlideChange={(swip: any) => setActiveIndex(swip.activeIndex)}
          className={
            activeIndex === 1 || activeIndex === 2 ? "special-class" : ""
          }
        >
          {banner_links.map((item, index) => (
            <SwiperSlide key={index} className="home_page_banner">
              <Link to={item.url}>
                <img
                  src={`/assets/img/banner/MESC_Banner_${item.banner}.png`}
                  alt="Banner"
                  className="home_page_banner_img desktop_img"
                />
                <img
                  src={`/assets/img/banner/MESC_Banner_mobile${item.banner}.png`}
                  alt="Banner"
                  className="home_page_banner_img_mobile mobile_img"
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="brand-area brand-area-two">
          <div className="container-fluid">
            <div className="marquee_mode" ref={marqueeRef}>
              {data?.page?.home?.homeBanner?.brandArea.map(
                (item: any, index: number) => (
                  <div className="brand__item" key={index}>
                    <Link to={item?.link}>
                      <img
                        src={item?.image?.node?.sourceUrl}
                        alt={item?.image?.node?.altText}
                      />
                    </Link>
                    <img src="assets/img/icons/brand_star.svg" alt="star" />
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        {data?.page?.home?.communitySection && (
          <CommunitySection data={data?.page?.home?.communitySection} />
        )}

        <section className="about-area-two tg-motion-effects section-pb-120">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-6">
                <div className="faq__img-wrap tg-svg">
                  <div className="faq__img" style={{ height: "500px" }}>
                    <img
                      src={
                        data?.page?.home?.aboutSection?.leftSideImage?.node
                          ?.sourceUrl
                      }
                      alt={
                        data?.page?.home?.aboutSection?.leftSideImage?.node
                          ?.altText
                      }
                    />
                    <div className="shape-one">
                      <img
                        src="assets/img/others/faq_shape01.svg"
                        className="injectable tg-motion-effects4"
                        alt="img"
                      />
                    </div>
                    <div className="shape-two">
                      <span
                        className="svg-icon"
                        id="faq-two-svg"
                        data-svg-icon="assets/img/others/faq_shape02.svg"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about__content">
                  <div className="section__title">
                    <span className="sub-title">
                      {data?.page?.home?.aboutSection?.rightSideSubTitle}
                    </span>
                    <h2 className="title">
                      Empowering{" "}
                      <span className="position-relative">
                        <svg
                          x="0px"
                          y="0px"
                          preserveAspectRatio="none"
                          viewBox="0 0 209 59"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.74438 7.70565C69.7006 -1.18799 136.097 -2.38304 203.934 4.1205C207.178 4.48495 209.422 7.14626 208.933 10.0534C206.793 23.6481 205.415 36.5704 204.801 48.8204C204.756 51.3291 202.246 53.5582 199.213 53.7955C136.093 59.7623 74.1922 60.5985 13.5091 56.3043C10.5653 56.0924 7.84371 53.7277 7.42158 51.0325C5.20725 38.2627 2.76333 25.6511 0.0898448 13.1978C-0.465589 10.5873 1.61173 8.1379 4.73327 7.70565"
                            fill="currentcolor"
                          />
                        </svg>
                        Skills
                      </span>
                      {" " + data?.page?.home?.aboutSection?.rightSideSubTitle1}
                    </h2>
                  </div>
                  <p className="desc" style={{ textAlign: "justify" }}>
                    {data?.page?.home?.aboutSection?.rightSideDescription}
                  </p>
                  <ul className="about__info-list list-wrap">
                    {data?.page?.home?.aboutSection?.rightSidePoints.length >
                      0 &&
                      data?.page?.home?.aboutSection?.rightSidePoints.map(
                        (item: any, key: number) => (
                          <li className="about__info-list-item" key={key}>
                            <i className="flaticon-angle-right"></i>
                            <p className="content">{item.points}</p>
                          </li>
                        )
                      )}
                  </ul>
                  <div className="tg-button-wrap">
                    <Link
                      to={data?.page?.home?.aboutSection?.rightSideButton?.url}
                      className="btn arrow-btn"
                    >
                      {data?.page?.home?.aboutSection?.rightSideButton?.title}
                      <RightArrowIcon />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <TwoColImageSection
          leftsideSection={twoColImageData?.leftSideSection}
          rightsideSection={twoColImageData?.rightSideSection}
        /> */}

        <ParallaxTwoColumn data={data?.page?.home?.videoParralaxSection} />

        <HomeCourses data={data} />

        <ParallaxSection data={data?.page?.home?.simpleParallexSection} />
        <ParallaxTwoColVideoSec data={data?.page?.home?.workArea} />

        <StatTiles data={data?.page?.home?.factArea} />

        <InstructorsSection data={data?.page?.home?.registerSections} />
        <Review
          message={data?.page?.home?.chairmainMessage?.description}
          designation={data?.page?.home?.chairmainMessage?.reviewSubTitle}
          name={data?.page?.home?.chairmainMessage?.reviewTitle}
          title={data?.page?.home?.chairmainMessage?.title}
          image={data?.page?.home?.chairmainMessage?.reviewImages}
        />

        {/* <section
          className="instructor__area-three instructor__bg"
          style={{ paddingTop: 65, paddingRight: 0, paddingBottom: 60 }}
          data-background="/assets/img/bg/instructor_bg.jpg"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-8">
                <div className="section__title text-center">
                  <span className="sub-title">
                    {data?.page?.home?.industryAreaSection?.highlightText}
                  </span>
                  <h2 className="title">
                    {data?.page?.home?.industryAreaSection?.title}
                  </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-8">
                <Swiper
                  className="instructor-active"
                  modules={[Thumbs, Autoplay]}
                  spaceBetween={0}
                  autoplay
                  thumbs={{
                    swiper:
                      thumbsSwiper && !thumbsSwiper.destroyed
                        ? thumbsSwiper
                        : null,
                  }}
                >
                  {data?.page?.home?.industryAreaSection?.industryAreaRepeater.map(
                    (item: any, index: number) => (
                      <SwiperSlide key={index}>
                        <div className="instructor__item-three">
                          <div
                            className="instructor__thumb-three"
                            style={{ marginBottom: 10 }}
                          >
                            <img
                              src={item?.industryHeadshot?.node?.sourceUrl}
                              alt={item?.industryHeadshot?.node?.altText}
                              width={318}
                              height={400}
                            />
                            <div className="shape-one">

                            </div>
                          </div>
                          <div className="instructor__content-three">
                            <h2 className="title">{item?.industryTitle}</h2>
                            <span
                              className="designation"
                              style={{ lineHeight: "25px", marginBottom: 5 }}
                            >
                              {item?.industryDescription}
                            </span>
                          </div>
                        </div>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-9">
                <Swiper
                  className="instructor-nav"
                  modules={[Navigation, Thumbs]}
                  spaceBetween={0}
                  slidesPerView={6}
                  onSwiper={(e: any) => setThumbsSwiper(e)}
                  breakpoints={{
                    1000: {
                      slidesPerView: 6,
                    },
                    500: {
                      slidesPerView: 2,
                    },
                  }}
                  navigation={{
                    
                    nextEl: ".instructor-button-next",
                    prevEl: ".instructor-button-prev",
                  }}
                >
                  {data?.page?.home?.industryAreaSection?.industryAreaRepeater.map(
                    (item: any, index: number) => (
                      <SwiperSlide key={index}>
                        <button>
                          <img
                            src={item?.industryHeadshot?.node?.sourceUrl}
                            alt={item?.industryHeadshot?.node?.altText}
                            width={97}
                            height={122}
                          />
                        </button>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
                <div className="instructor__nav-two">
                  <div className="instructor-button-prev">
                    <i className="flaticon-arrow-right"></i>
                  </div>
                  <div className="instructor-button-next">
                    <i className="flaticon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="instructor__shape">
            <img
              src="/assets/img/instructor/h2_instructor_shape.png"
              alt="img-text"
              className="alltuchtopdown"
              width={109}
              height={100}
            />
          </div>
        </section> */}

        <section
          className="instructor__area-three instructor__bg"
          style={{ paddingTop: 65, paddingRight: 0, paddingBottom: 60 }}
          data-background="/assets/img/bg/instructor_bg.jpg"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-8">
                <div className="section__title text-center">
                  <span className="sub-title">
                    {data?.page?.home?.industryAreaSection?.highlightText}
                  </span>
                  <h2 className="title">
                    {data?.page?.home?.industryAreaSection?.title}
                  </h2>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xl-8">
                <div className="swiper-container instructor-active">
                  <div className="swiper-wrapper">
                    {currentSelectedItem && (
                      <div className="swiper-slide">
                        <div className="instructor__item-three">
                          <div
                            className="instructor__thumb-three"
                            style={{ marginBottom: 10 }}
                          >
                            <img
                              src={
                                currentSelectedItem?.industryHeadshot?.node
                                  ?.sourceUrl
                              }
                              alt={
                                currentSelectedItem?.industryHeadshot?.node
                                  ?.altText
                              }
                              width={318}
                              height={400}
                            />
                            <div className="shape-one">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="401"
                                height="394"
                                viewBox="0 0 401 394"
                                fill="none"
                                data-inject-url="/assets/img/instructor/h2_instructor_img_shape01.svg"
                                className="injectable"
                              >
                                <path
                                  d="M21.1658 199.323C21.1323 159.006 53.7884 126.295 94.1051 126.262L306.105 126.086C346.422 126.052 379.132 158.708 379.166 199.025C379.199 239.342 346.543 272.052 306.226 272.086L94.2265 272.262C53.9097 272.295 21.1994 239.639 21.1658 199.323Z"
                                  fill="currentcolor"
                                ></path>
                                <path
                                  d="M0.264675 318.34C0.230238 276.919 33.781 243.312 75.2023 243.278L325.202 243.07C366.624 243.036 400.23 276.586 400.265 318.008C400.299 359.429 366.748 393.036 325.327 393.07L75.327 393.278C33.9057 393.312 0.299112 359.762 0.264675 318.34Z"
                                  fill="currentcolor"
                                ></path>
                              </svg>
                            </div>
                          </div>
                          <div className="instructor__content-three">
                            <h2 className="title">
                              {currentSelectedItem?.industryTitle}
                            </h2>
                            <span
                              className="designation"
                              style={{
                                lineHeight: "25px",
                                marginBottom: 5,
                              }}
                            >
                              {currentSelectedItem?.industryDescription}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-9">
                <div className="instructor-slider-dot">
                  <div className="swiper instructor-nav">
                    <div className="swiper-wrapper">
                      <Swiper
                        modules={[Autoplay, Navigation]}
                        slidesPerView={6}
                        observer={true}
                        loop={true}
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        spaceBetween={0}
                        // breakpoints={{
                        //   1500: { slidesPerView: 6 },
                        //   1200: { slidesPerView: 6 },
                        //   992: { slidesPerView: 4, spaceBetween: 0 },
                        //   768: { slidesPerView: 3, spaceBetween: 0 },
                        //   640: { slidesPerView: 2 },
                        //   576: { slidesPerView: 2 },
                        //   0: { slidesPerView: 2 },
                        // }}
                        navigation={{
                          nextEl: ".instructor-button-next",
                          prevEl: ".instructor-button-prev",
                        }}
                      >
                        {data?.page?.home?.industryAreaSection
                          ?.industryAreaRepeater.length > 0 &&
                          data?.page?.home?.industryAreaSection?.industryAreaRepeater.map(
                            (item: any, index: number) => (
                              <SwiperSlide
                                onClick={() => setCurrentSelectedItem(item)}
                                key={index}
                              >
                                <div className="swiper-slide" key={index}>
                                  <button>
                                    <img
                                      src={
                                        item?.industryHeadshot?.node?.sourceUrl
                                      }
                                      alt={
                                        item?.industryHeadshot?.node?.altText
                                      }
                                      width={97}
                                      height={122}
                                    />
                                  </button>
                                </div>
                              </SwiperSlide>
                            )
                          )}
                      </Swiper>
                    </div>
                  </div>
                  <div className="instructor__nav-two">
                    <div className="instructor-button-prev">
                      <i className="flaticon-arrow-right"></i>
                    </div>
                    <div className="instructor-button-next">
                      <i className="flaticon-arrow-right"></i>
                    </div>
                  </div>
                </div>

                {/* <div className="instructor-slider-dot">
                  <div className="swiper instructor-nav">
                    <div className="swiper-wrapper">
                      {data?.page?.home?.industryAreaSection
                        ?.industryAreaRepeater.length > 0 &&
                        data?.page?.home?.industryAreaSection?.industryAreaRepeater.map(
                          (item: any, index: number) => (
                            <div className="swiper-slide" key={index}>
                              <button>
                                <img
                                  src={item?.industryHeadshot?.node?.sourceUrl}
                                  alt={item?.industryHeadshot?.node?.altText}
                                  width={97}
                                  height={122}
                                />
                              </button>
                            </div>
                          )
                        )}
                    </div>
                  </div>
                  <div className="instructor__nav-two">
                    <div className="instructor-button-prev">
                      <i className="flaticon-arrow-right"></i>
                    </div>
                    <div className="instructor-button-next">
                      <i className="flaticon-arrow-right"></i>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="instructor__shape">
            <img
              src="/assets/img/instructor/h2_instructor_shape.png"
              alt="img-text"
              className="alltuchtopdown"
              width={109}
              height={100}
            />
          </div>
        </section>

        <Magazine
          data={data?.page?.home?.eventAreaSection}
          magazinesContents={data?.eMagazinesContents}
        />

        <IndustryPartners data={data?.page?.home?.brandSection} />

        <CallToAction
          title={data?.page?.home?.ctaSection?.title}
          subTitle={data?.page?.home?.ctaSection?.subTitle}
          button={data?.page?.home?.ctaSection?.buttonLink}
          image={data?.page?.home?.ctaSection?.ctaImage}
        />
      </main>
    </>
  );
}
